import * as path from 'path';
import AbstractConfig from './AbstractConfig';
import { PathParts } from '@/types';

export default class ShowcaseConfig extends AbstractConfig {
  public wallpaper(): string {
    return this.pathPartsToFilepath(this.get<PathParts>('wallpaper'));
  }

  public static(): string | null {
    if (!this.has('static')) {
      return null;
    }

    return this.pathPartsToFilepath(this.get<PathParts>('static'));
  }

  protected pathPartsToFilepath(parts: PathParts) {
    const { directory, basename } = parts;

    return path.join(directory, basename);
  }
}
